import React from 'react'
import { Skeleton } from '@material-ui/lab'

const Loading: React.FC = (props) => <Skeleton />

export default Loading
